// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Map = require("rescript/lib/js/belt_Map.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Command$SmartcutsMacros = require("./Command.bs.js");
var URLUtils$SmartcutsMacros = require("../../bs-utils/src/URLUtils.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var CommandLog$SmartcutsMacros = require("./CommandLog.bs.js");
var Exceptions$SmartcutsMacros = require("./Exceptions.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var SmartcutIds$SmartcutsMacros = require("./SmartcutIds.bs.js");
var ScheduledTrigger$SmartcutsMacros = require("./ScheduledTrigger.bs.js");

function t_encode(v) {
  if (typeof v !== "number") {
    return [
            "Origin",
            Decco.stringToJson(v._0)
          ];
  }
  switch (v) {
    case /* Alarms */0 :
        return ["Alarms"];
    case /* Idle */1 :
        return ["Idle"];
    case /* Downloads */2 :
        return ["Downloads"];
    case /* ClipboardRead */3 :
        return ["ClipboardRead"];
    case /* ClipbordWrite */4 :
        return ["ClipbordWrite"];
    case /* WebNavigation */5 :
        return ["WebNavigation"];
    case /* Tabs */6 :
        return ["Tabs"];
    case /* AllUrls */7 :
        return ["AllUrls"];
    
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Alarms" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Alarms */0
                  };
          }
      case "AllUrls" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AllUrls */7
                  };
          }
      case "ClipboardRead" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ClipboardRead */3
                  };
          }
      case "ClipbordWrite" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ClipbordWrite */4
                  };
          }
      case "Downloads" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Downloads */2
                  };
          }
      case "Idle" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Idle */1
                  };
          }
      case "Origin" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* Origin */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Tabs" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Tabs */6
                  };
          }
      case "WebNavigation" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* WebNavigation */5
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function toString(v) {
  if (typeof v !== "number") {
    return v._0;
  }
  switch (v) {
    case /* Alarms */0 :
        return "alarms";
    case /* Idle */1 :
        return "idle";
    case /* Downloads */2 :
        return "downloads";
    case /* ClipboardRead */3 :
        return "clipboardRead";
    case /* ClipbordWrite */4 :
        return "clipboardWrite";
    case /* WebNavigation */5 :
        return "webNavigation";
    case /* Tabs */6 :
        return "tabs";
    case /* AllUrls */7 :
        return "<all_urls>";
    
  }
}

function forRecording(param) {
  return [
          /* Downloads */2,
          /* WebNavigation */5,
          /* Tabs */6,
          /* ClipboardRead */3,
          /* AllUrls */7
        ];
}

function originFromUrlString(urlString) {
  var url$p = URLUtils$SmartcutsMacros.$$URL.fromString(urlString);
  var url;
  if (url$p !== undefined) {
    url = url$p;
  } else {
    throw {
          RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
          _1: urlString,
          Error: new Error()
        };
  }
  url.hash = "";
  url.search = "";
  url.pathname = "*";
  return url.toString();
}

function forPlayback(commandLog, origins) {
  var originPermissions = CommandLog$SmartcutsMacros.GlobalForPlayback.doesNotKnowAllUrlsAheadOfTime(commandLog) ? [/* AllUrls */7] : Belt_Array.map(ArrayUtils$SmartcutsMacros.unique(Belt_Array.map(origins, originFromUrlString)), (function (origin) {
            return /* Origin */{
                    _0: origin
                  };
          }));
  return $$Array.concat({
              hd: originPermissions,
              tl: {
                hd: [
                  /* WebNavigation */5,
                  /* Tabs */6,
                  /* ClipboardRead */3,
                  /* ClipbordWrite */4
                ],
                tl: {
                  hd: Belt_List.some(commandLog, (function (param) {
                          return Command$SmartcutsMacros.ForPlayback.isDownloadCommand(param.command);
                        })) ? [/* Downloads */2] : [],
                  tl: /* [] */0
                }
              }
            });
}

function forUrlTriggering(param) {
  return [/* WebNavigation */5];
}

function forScheduledPlayback(commandLog, origins) {
  return Belt_Array.concat(forPlayback(commandLog, origins), [
              /* Alarms */0,
              /* Idle */1
            ]);
}

function isPermission(v) {
  if (typeof v === "number") {
    return v < 7;
  } else {
    return false;
  }
}

function isOrigin(v) {
  if (typeof v === "number") {
    return v >= 7;
  } else {
    return true;
  }
}

function shouldRemove(v) {
  if (typeof v === "number") {
    return !(v > 6 || v < 2);
  } else {
    return false;
  }
}

function toBrowserPermissions(permissionsAndOrigins) {
  return {
          origins: Belt_Array.map(Belt_Array.keep(permissionsAndOrigins, isOrigin), toString),
          permissions: Belt_Array.map(Belt_Array.keep(permissionsAndOrigins, isPermission), toString)
        };
}

function t_encode$1(v) {
  if (typeof v === "number") {
    switch (v) {
      case /* ViaStartRecording */0 :
          return ["ViaStartRecording"];
      case /* ViaMultiUrlTriggering */1 :
          return ["ViaMultiUrlTriggering"];
      case /* ViaMultiUrlTriggeringSetup */2 :
          return ["ViaMultiUrlTriggeringSetup"];
      case /* ViaNextExecutionSet */3 :
          return ["ViaNextExecutionSet"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* ViaResyncScheduledTriggers */0 :
          return [
                  "ViaResyncScheduledTriggers",
                  Decco.arrayToJson(ScheduledTrigger$SmartcutsMacros.t_encode, v._0)
                ];
      case /* ViaReceivedMessageToInitializePlayback */1 :
          return [
                  "ViaReceivedMessageToInitializePlayback",
                  Decco.stringToJson(v._0)
                ];
      case /* ViaCreateScheduledTrigger */2 :
          return [
                  "ViaCreateScheduledTrigger",
                  ScheduledTrigger$SmartcutsMacros.t_encode(v._0)
                ];
      case /* ViaReceivedMessageToUpsertExecutionSetThatWeNeedToQueue */3 :
          return [
                  "ViaReceivedMessageToUpsertExecutionSetThatWeNeedToQueue",
                  SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0)
                ];
      
    }
  }
}

function t_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ViaCreateScheduledTrigger" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = ScheduledTrigger$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ViaCreateScheduledTrigger */2,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "ViaMultiUrlTriggering" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ViaMultiUrlTriggering */1
                  };
          }
      case "ViaMultiUrlTriggeringSetup" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ViaMultiUrlTriggeringSetup */2
                  };
          }
      case "ViaNextExecutionSet" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ViaNextExecutionSet */3
                  };
          }
      case "ViaReceivedMessageToInitializePlayback" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ViaReceivedMessageToInitializePlayback */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ViaReceivedMessageToUpsertExecutionSetThatWeNeedToQueue" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ViaReceivedMessageToUpsertExecutionSetThatWeNeedToQueue */3,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "ViaResyncScheduledTriggers" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Decco.arrayFromJson(ScheduledTrigger$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ViaResyncScheduledTriggers */0,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "ViaStartRecording" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ViaStartRecording */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function justVariantStringMinusParams(v) {
  if (typeof v === "number") {
    switch (v) {
      case /* ViaStartRecording */0 :
          return "ViaStartRecording";
      case /* ViaMultiUrlTriggering */1 :
          return "ViaMultiUrlTriggering";
      case /* ViaMultiUrlTriggeringSetup */2 :
          return "ViaMultiUrlTriggeringSetup";
      case /* ViaNextExecutionSet */3 :
          return "ViaNextExecutionSet";
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* ViaResyncScheduledTriggers */0 :
          return "ViaResyncScheduledTriggers";
      case /* ViaReceivedMessageToInitializePlayback */1 :
          return "ViaReceivedMessageToInitializePlayback(" + v._0 + ")";
      case /* ViaCreateScheduledTrigger */2 :
          return "ViaCreateScheduledTrigger";
      case /* ViaReceivedMessageToUpsertExecutionSetThatWeNeedToQueue */3 :
          return "ViaReceivedMessageToUpsertExecutionSetThatWeNeedToQueue";
      
    }
  }
}

function toReasonSuffix(permissionTrigger) {
  if (typeof permissionTrigger === "number") {
    switch (permissionTrigger) {
      case /* ViaStartRecording */0 :
          return " record your actions to create your smartcut.";
      case /* ViaMultiUrlTriggeringSetup */2 :
          return " detect when you page through results.";
      default:
        return " replay your smartcut.";
    }
  } else {
    switch (permissionTrigger.TAG | 0) {
      case /* ViaResyncScheduledTriggers */0 :
          return " replay smartcuts that you have previously set up to run on a schedule.";
      case /* ViaCreateScheduledTrigger */2 :
          return " replay your actions for a scheduled automation.";
      default:
        return " replay your smartcut.";
    }
  }
}

var PermissionTrigger = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  justVariantStringMinusParams: justVariantStringMinusParams,
  toReasonSuffix: toReasonSuffix
};

function fromScheduledTriggers(loadableSmartcutsById, scheduledTriggers) {
  var activeTriggers = Belt_Array.keep(scheduledTriggers, (function (param) {
          return param.status === "ACTIVE";
        }));
  return Belt_Array.reduce(activeTriggers, [
              /* Alarms */0,
              /* Idle */1
            ], (function (permissions, param) {
                var installedSmartcutId = param.installedSmartcutId;
                var arg = OptionUtils$SmartcutsMacros.map(Util$SmartcutsMacros.Loadable.getLoadedValue(loadableSmartcutsById), (function (smartcutsById) {
                        var match = Belt_Map.get(smartcutsById, installedSmartcutId);
                        var tmp;
                        if (match !== undefined) {
                          var commandLogData = match.commandLogData;
                          tmp = commandLogData.TAG === /* Decoded */0 ? $$Array.append(permissions, forPlayback(commandLogData._0, match.origins)) : permissions;
                        } else {
                          tmp = permissions;
                        }
                        return ArrayUtils$SmartcutsMacros.unique(tmp);
                      }));
                return OptionUtils$SmartcutsMacros.withDefault(permissions, arg);
              }));
}

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.toString = toString;
exports.forRecording = forRecording;
exports.originFromUrlString = originFromUrlString;
exports.forPlayback = forPlayback;
exports.forUrlTriggering = forUrlTriggering;
exports.forScheduledPlayback = forScheduledPlayback;
exports.shouldRemove = shouldRemove;
exports.toBrowserPermissions = toBrowserPermissions;
exports.PermissionTrigger = PermissionTrigger;
exports.fromScheduledTriggers = fromScheduledTriggers;
/* Util-SmartcutsMacros Not a pure module */
